import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { apiRequest } from "@/api/client";

const AuthContext = createContext(null);

export const roleLabels = {
  SUPER_ADMIN: "Super Admin",
  CONSULENTE: "Consulente",
  AZIENDA_ADMIN: "Admin azienda",
  RSPP: "RSPP",
  MEDICO_COMPETENTE: "Medico competente",
  RLS: "RLS",
  LETTORE: "Lettore",
  auditor_esterno: "Auditor esterno",
  auditor: "Auditor",
};

export const appRoles = Object.keys(roleLabels).filter((r) => r !== "auditor_esterno" && r !== "auditor"); // questi ruoli li crea chi gestisce, non ci si registra

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dvr_token");
    if (!token) {
      setLoading(false);
      return;
    }
    apiRequest("/auth/me")
      .then((u) => { setUser(u); localStorage.setItem("dvr_user", JSON.stringify(u)); })
      .catch((err) => {
        // senza rete (fetch fallita, nessuno status) si resta dentro con l'ultimo profilo noto: l'app da campo deve aprirsi offline
        if (err.status === 401 || err.status === 403) { localStorage.removeItem("dvr_token"); localStorage.removeItem("dvr_user"); return; }
        try { const cached = JSON.parse(localStorage.getItem("dvr_user") || "null"); if (cached) setUser(cached); } catch { /* profilo non leggibile */ }
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, otp) => {
    const data = await apiRequest("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password, ...(otp ? { otp } : {}) }),
    });
    localStorage.setItem("dvr_token", data.token);
    localStorage.setItem("dvr_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const data = await apiRequest("/auth/register", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    localStorage.setItem("dvr_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("dvr_token");
    localStorage.removeItem("dvr_user");
    setUser(null);
  };

  const value = useMemo(() => ({ user, loading, login, register, logout }), [user, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth deve essere usato dentro AuthProvider");
  return context;
}